<template>
  <div class="news">
    <!-- 页面标题 -->
    <section class="page-header text-white py-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-8">
            <h1 class="page-title">{{ $t('news.title') }}</h1>
            <p class="page-subtitle">{{ $t('news.subtitle') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 央视专访 视频 -->
    <section class="feature-video py-5">
      <div class="feature-orbs"><span></span><span></span></div>
      <div class="container position-relative">
        <div class="row align-items-center">
          <div class="col-lg-5 mb-4 mb-lg-0 wow animate__fadeInLeft">
            <span class="feature-eyebrow"><i class="fas fa-circle-play mr-2"></i>{{ $t('news.videoEyebrow') }}</span>
            <h2 class="feature-title" v-html="$t('news.videoTitle')"></h2>
            <p class="feature-desc">{{ $t('news.videoDesc') }}</p>
            <ul class="feature-points list-unstyled">
              <li v-for="(pt, i) in $t('news.videoPoints')" :key="i"><i class="fas fa-check-circle mr-2"></i>{{ pt }}</li>
            </ul>
          </div>
          <div class="col-lg-7 wow animate__fadeInRight">
            <div class="video-frame">
              <video class="interview-video" controls preload="metadata" :poster="videoPoster" playsinline>
                <source :src="videoSrc" type="video/mp4">
                {{ $t('news.videoUnsupported') }}
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 荣誉资质 -->
    <section class="honors-section py-5">
      <div class="container">
        <div class="section-header text-center mb-5">
          <h2 class="section-title">{{ $t('news.honorsTitle') }}</h2>
          <p class="section-subtitle">{{ $t('news.honorsSub') }}</p>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6 mb-4 wow animate__fadeInUp" :data-wow-delay="(index % 3 * 0.12) + 's'" v-for="(honor, index) in honors" :key="honor.id">
            <div class="honor-card bg-white rounded shadow-sm h-100 overflow-hidden">
              <div class="honor-img">
                <img :src="honor.img" :alt="honor.title">
                <span class="honor-year badge" v-if="honor.year">{{ honor.year }}</span>
              </div>
              <div class="honor-body p-4">
                <h5 class="honor-title">{{ honor.title }}</h5>
                <p class="honor-desc text-muted mb-0">{{ honor.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 媒体报道 -->
    <section class="media-section py-5 bg-light">
      <div class="container">
        <div class="section-header text-center mb-5">
          <h2 class="section-title">{{ $t('news.mediaTitle') }}</h2>
          <p class="section-subtitle">{{ $t('news.mediaSub') }}</p>
        </div>
        <div class="row">
          <div class="col-lg-6 mb-3" v-for="media in mediaLinks" :key="media.id">
            <a :href="media.url" target="_blank" rel="noopener" class="media-item d-flex align-items-center p-3 bg-white rounded shadow-sm">
              <i class="fas fa-link text-primary mr-3"></i>
              <div class="media-text">
                <div class="media-source">{{ media.source }}</div>
                <div class="media-url text-muted small">{{ media.url }}</div>
              </div>
              <i class="fas fa-arrow-right ml-auto text-muted"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { WOW } from 'wowjs'
import imgCri from '../assets/honor/cri.png'
import imgCctv from '../assets/honor/cctv.png'
import imgCraftsmanship from '../assets/honor/craftsmanship.png'
import imgScientist from '../assets/honor/scientist.png'
import imgAscend from '../assets/honor/ascend.png'
import imgCaseset from '../assets/honor/caseset.png'
import imgMeeting from '../assets/honor/meeting.png'

export default {
  name: 'News',
  data() {
    return {
      videoSrc: process.env.BASE_URL + 'video/cctv.mp4',
      videoPoster: imgCctv,
      honorMeta: [
        { id: 1, year: '2026', img: imgCri },
        { id: 3, img: imgCraftsmanship },
        { id: 4, img: imgScientist },
        { id: 5, year: '2025', img: imgAscend },
        { id: 6, year: '2025', img: imgCaseset },
        { id: 7, year: '2025', img: imgMeeting }
      ],
      mediaLinks: [
        { id: 1, source: '中国科技日报', url: 'http://www.zgkejizx.com/article/202601infos3182.html' },
        { id: 2, source: 'MBA中国网', url: 'https://www.mbachina.com/html/mbachina/202601/639925.html' },
        { id: 3, source: '中国科技时报周刊', url: 'http://www.liuzhourex.cn/xinwen/1199176.html' },
        { id: 4, source: '百度新闻', url: 'https://baijiahao.baidu.com/s?id=1854986433606203163' },
        { id: 5, source: '中国网', url: 'https://www.naddc.com.cn/anhui/article/detail-385866.html' },
        { id: 6, source: '今日头条', url: 'https://www.douyin.com/video/7597734656159043426' },
        { id: 7, source: '深港网', url: 'https://www.sgxww.net/china/2026-05-18/89372.html' }
      ]
    }
  },
  computed: {
    honors() {
      const text = this.$t('news.honors')
      return this.honorMeta.map((h, i) => ({
        id: h.id,
        year: h.year,
        img: h.img,
        title: text[i] ? text[i].title : '',
        desc: text[i] ? text[i].desc : ''
      }))
    }
  },
  mounted() {
    try {
      // eslint-disable-next-line no-new
      new WOW({ boxClass: 'wow', animateClass: 'animate__animated', offset: 60, mobile: true, live: false }).init()
    } catch (e) { /* noop */ }
  }
}
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #002850 0%, #0a4d8c 100%);
}
.page-title { font-size: 2.5rem; font-weight: bold; }
.page-subtitle { font-size: 1.1rem; opacity: 0.9; }

.honor-card { transition: transform 0.3s ease, box-shadow 0.3s ease; }
.honor-card:hover { transform: translateY(-6px); box-shadow: 0 14px 30px rgba(0, 40, 80, 0.14) !important; }
.honor-img {
  position: relative;
  height: 210px;
  background: #f1f5fa;
  overflow: hidden;
  display: flex; align-items: center; justify-content: center;
}
.honor-img img { width: 100%; height: 100%; object-fit: cover; object-position: top center; }
.honor-year {
  position: absolute; top: 10px; left: 10px;
  background: #007bff; color: #fff;
  font-size: 0.78rem; padding: 4px 10px; border-radius: 999px;
}
.honor-title { font-weight: 700; font-size: 1.02rem; }
.honor-desc { font-size: 0.9rem; line-height: 1.7; }

.media-item { color: inherit; text-decoration: none; transition: transform 0.3s ease, box-shadow 0.3s ease; }
.media-item:hover { transform: translateY(-3px); box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12) !important; text-decoration: none; }
.media-source { font-weight: 600; }
.media-url { word-break: break-all; }

/* 央视专访视频 */
.feature-video {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #061528 0%, #0c2c52 60%, #0a2240 100%);
  color: #fff;
}
.feature-orbs span {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  opacity: 0.4;
  animation: orbFloat 14s ease-in-out infinite;
}
.feature-orbs span:nth-child(1) { width: 360px; height: 360px; top: -120px; right: -60px; background: #2f80ed; }
.feature-orbs span:nth-child(2) { width: 260px; height: 260px; bottom: -100px; left: 4%; background: #e23d3d; opacity: 0.28; animation-delay: -6s; }
@keyframes orbFloat {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-22px, 24px) scale(1.1); }
}
.feature-eyebrow {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 999px;
  background: rgba(226, 61, 61, 0.18);
  color: #ff8a8a;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}
.feature-title { font-weight: 800; font-size: 2rem; line-height: 1.35; margin-bottom: 1.2rem; }
.feature-desc { color: rgba(255, 255, 255, 0.82); line-height: 1.9; }
.feature-points li { margin-top: 0.6rem; color: rgba(255, 255, 255, 0.9); }
.feature-points i { color: #20c997; }

.video-frame {
  position: relative;
  border-radius: 18px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
}
.video-frame::after {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(47,128,237,0.5), rgba(32,201,151,0.4));
  z-index: -1;
  filter: blur(14px);
  opacity: 0.7;
}
.interview-video {
  width: 100%;
  display: block;
  border-radius: 12px;
  background: #000;
  aspect-ratio: 16 / 9;
  object-fit: cover;
}

@media (max-width: 768px) {
  .feature-title { font-size: 1.5rem; }
}
</style>
